import { useEffect, useState } from "react";
import { Banknote, BarChart3, Briefcase, Clock, Bike, Boxes, CalendarClock, Car, ChefHat, ClipboardList, FileText, Gift, Grid3x3, Navigation, Package, Puzzle, QrCode, ShoppingCart, Ticket, Users, Wallet, Zap } from "lucide-react";
import { api, MODULE_LABELS } from "@/lib/api";

const ICONS = {
  pdv: ShoppingCart, caixa: Wallet, encomendas: CalendarClock, mesas: Grid3x3, comandas: ClipboardList, delivery: Bike, boy_express: Zap,
  fidelidade: Gift, producao: ChefHat, tickets: Ticket, estacionamento: Car, cardapio: QrCode, produtos: Package, estoque: Boxes,
  clientes: Users, relatorios: BarChart3, motoboy: Navigation, fiscal: FileText, folha: Banknote, ponto: Clock, contabil: Briefcase,
};
export const moduleIcon = (id) => ICONS[id] || Puzzle;

let cache = null;
export function useModuleCatalog() {
  const [list, setList] = useState([]);
  useEffect(() => {
    let alive = true;
    cache = cache || api.get("/public/modules").then((r) => r.data).catch(() => { cache = null; return []; });
    cache.then((d) => { if (alive) setList(d); });
    return () => { alive = false; };
  }, []);
  return list;
}

export const planModuleItems = (modules, catalog) => (catalog.length
  ? catalog.filter((c) => modules.includes(c.id))
  : modules.map((id) => ({ id, label: MODULE_LABELS[id] || id, description: "" })));

export const modulePrice = (plan, m) => Number(plan.module_prices?.[m]) || 0;

export function customTotals(plan, mods) {
  const monthly = mods.reduce((s, m) => s + Math.round(modulePrice(plan, m) * 100), 0) / 100;
  return { monthly, yearly: Math.round(monthly * 12 * (1 - (Number(plan.yearly_discount ?? 15) || 0) / 100) * 100) / 100 };
}

export function startingPrice(plan) {
  const prices = plan.modules.map((m) => modulePrice(plan, m)).filter((v) => v > 0);
  return prices.length ? Math.min(...prices) : 0;
}

const CHOICE_KEY = "fsc_plan_choice";
export function readChoice() {
  try {
    return JSON.parse(localStorage.getItem(CHOICE_KEY))?.modules || [];
  } catch {
    return [];
  }
}
export const saveChoice = (modules) => localStorage.setItem(CHOICE_KEY, JSON.stringify({ modules }));
